// import createPersistedState from 'vuex-persistedstate'
import * as apiCommon from '@/api/common'
import * as apiKnowledge from '@/api/knowledge'
import * as apiBookmark from '@/api/bookmark'
import * as apiNote from '@/api/note'
import * as apiGA from '@/api/ga'
import * as _ from 'lodash'
import { breakComma, getDataURL, getValuesfromNest } from '@/util/common'

const getDefaultState = () => {
  const defaults = {
    search: {
      keyword: '',
      search_date_start: null,
      search_date_end: null,
      is_fuzzy: 0, // 表記の揺れを含む：0(曖昧検索),1(一致検索)
      category: [],
      start: 0,
      per_page: 30,
      ascending: 'created_desc',
      is_paginate: 0,
      selectedListItemId: 0 // 詳細画面から一覧画面に戻ってきた時のスクロール位置指定用ID (最新ナレッジID)
    },
    hidden_keys: [
      'detail',
      'created',
      'note_count',
      'knowledge_category'
    ],
    categories: [],
    lists: [],
    noteLists: [],
    knowledge_id: null,
    // count: null,
    current_id: null,
    pagenation: {
      count: null,
      currentPage: 1
    },
    detail: {
      title: '',
      created: '',
      medium_name: '',
      medium_category: '',
      medium_category_name: '',
      sub_title: '',
      classification: '',
      detail: '',
      bookmarks_id: 0
    },
    product_codes: [],
    referrer: null,
    prev_url: null,
    isSearching: false
  }

  return defaults
}
const knowledge = {
  // plugins: [createPersistedState({ key: 'lc-app' })], // LocalStorageに保存する場合はコメント解除
  namespaced: true,
  state: getDefaultState(),
  getters: {
    categorySearchObj: (state) => {
      const saveParam = ['keyword', 'search_date_start', 'search_date_end', 'is_fuzzy']
      const obj = _.pickBy(state.search, (value, key) => {
        return saveParam.includes(key) && (value !== null && value !== '')
      })

      return obj
    },
    countSearchObj: (state) => {
      const saveParam = ['keyword', 'search_date_start', 'search_date_end', 'is_fuzzy', 'category']
      const obj = _.pickBy(state.search, (value, key) => {
        return saveParam.includes(key) && (value !== null && value !== '')
      })

      return obj
    },
    listSearchObj: (state) => {
      const obj = _.pickBy(state.search, (value, key) => {
        return (value !== null && value !== '')
      })

      return obj
    },
    ascendigName: (state, getters) => {
      const name = (getters.isSearch && state.search.keyword !== '' && state.search.ascending === 'score')
        ? '関連度順'
        : (state.search.ascending === 'created_desc') ? '作成日（新しい順）'
          : (state.search.ascending === 'created_asc') ? '作成日（古い順）'
            : '作成日（新しい順）'
      return name
    },
    countLists: (state) => {
      const string = _.isNumber(state.pagenation.count)
        ? breakComma(state.pagenation.count)
        : ''

      return string
    },
    isSearch: (state) => {
      return !!(state.search.keyword ||
        state.search.category.length > 0 ||
        state.search.search_date_start ||
        state.search.search_date_end)
    }
  },
  mutations: {
    setCategories(state, { list }) {
      state.categories = list
    },
    setLists(state, { list }) {
      state.lists = list
    },
    setDetail(state, { data }) {
      // state.detail = { ...data }
      Object.assign(state.detail, data)
    },
    setProductCodes(state, data) {
      // state.product_codes = { ...data }
      Object.assign(state.product_codes, data)
    },
    setSearchCategory(state, ids) {
      // 検索条件などDBに保存した値がstringになっているので一度intに変換
      const intIds = _.map(ids, id => parseInt(id))
      state.search.category = _.union(state.search.category, intIds)
      // state.search.category.push(id)
    },
    setSearchValue(state, value) {
      const { searchDateStart, searchDateEnd, isFuzzy, keyword } = value
      state.search.search_date_start = searchDateStart ?? null
      state.search.search_date_end = searchDateEnd ?? null
      state.search.is_fuzzy = isFuzzy ?? 0
      state.search.keyword = keyword ?? ''
    },
    setKeyword(state, keyword) {
      state.search.keyword = keyword
    },
    setIsFuzzy(state, isFuzzy) {
      state.search.is_fuzzy = isFuzzy
    },
    deleteSearchCategory(state, ids) {
      state.search.category = _.difference(state.search.category, ids)
      // state.search.category.splice(index, 1)
    },
    resetSearchCategory(state) {
      state.search.category.splice(0)
    },
    setAscending(state, value) {
      state.search.ascending = value
    },
    setPerpage(state, value) {
      state.search.per_page = value
    },
    setHiddenKeys(state, value) {
      state.hidden_keys = value
    },
    resetSearchConditions(state) {
      Object.assign(state, getDefaultState())
    },
    setCount(state, count) {
      state.pagenation.count = count
    },
    setPageNation(state, { currentPage, start }) {
      state.pagenation.currentPage = currentPage
      state.search.start = start
      state.search.is_paginate = 1
    },
    resetPageNation(state) {
      const { search, pagenation } = getDefaultState()
      state.search.start = search.start
      state.search.is_paginate = search.is_paginate
      state.pagenation.count = pagenation.count
      state.pagenation.currentPage = pagenation.currentPage
    },
    setBookmark(state, id) {
      state.detail.bookmarks_id = id
    },
    setViewLater(state, { index, afterId }) {
      const prev = state.lists[index]
      prev.after_id = afterId
      state.lists.splice(index, 1, prev)
    },
    listSearchStart(state) {
      state.isSearching = true
    },
    listSearchEnd(state) {
      state.isSearching = false
    },
    setSeachKnowledge(state, value) {
      state.knowledge_id = value
    },
    setNoteLists(state, value) {
      state.noteLists = value
    },
    resetNoteLists(state) {
      state.noteLists = []
    },
    setUserImage(state, list) {
      const index = state.noteLists.findIndex((u) => u.id === list.id)
      const tmpLsists = state.noteLists
      tmpLsists[index] = list
      state.noteLists = [...tmpLsists]
    },
    resetAll(state) {
      Object.assign(state, getDefaultState())
    },
    setReferrer(state, referrer) {
      state.referrer = referrer
    },
    setPrevUrl(state, url) {
      state.prev_url = url
    },
    setSelectedListItemId(state, selectedListItemId) {
      state.selectedListItemId = selectedListItemId
    }
  },
  actions: {
    setSearchOption({ dispatch, commit, state, rootState }, options) {
      const { common: { device } } = rootState
      const now = {
        per_page: state.search.per_page,
        ascending: state.search.ascending,
        hidden_keys: state.hidden_keys
      }
      const data = { ...now, ...options }
      const params = {
        setting_key: `${device}_knowledge_order_disp_settings`,
        setting_value: data
      }
      apiCommon
        .updateUserSetting(params)
        .then(response => {
          const data = response.data
          params.setting_value.ascending && commit('setAscending', params.setting_value.ascending)
          params.setting_value.per_page && commit('setPerpage', params.setting_value.per_page)
          params.setting_value.hidden_keys && commit('setHiddenKeys', params.setting_value.hidden_keys)
          if (data.status === 0) {
            dispatch('getKnowledgeLists')
          }
        })
    },
    async setPagenation({ commit }, payload) {
      await commit('setPageNation', payload)
    },
    async resetPagenation({ commit }) {
      await commit('resetPageNation')
    },
    setSeachCategory({ dispatch, state, commit }, { checked, value, allId }) {
      (checked)
        ? commit('setSearchCategory', allId)
        : commit('deleteSearchCategory', allId)
      dispatch('getKnowledgeLists')

    },
    preSetCategory({ commit }, ids) {
      commit('setSearchCategory', ids)
    },
    async setSearchValue({ commit }, value) {
      const save = {
        keyword: value.keyword,
        searchDateStart: value.search_date_start,
        searchDateEnd: value.search_date_end,
        isFuzzy: value.is_fuzzy ?? 0
        // isFuzzy: value.is_fuzzy || value.is_fuzzy === '0' ? 1 : 0
      }
      await commit('setSearchValue', save)
    },
    async setKeyword({ commit }, keyword) {
      await commit('setKeyword', keyword)
    },
    async setIsFuzzy({ commit }, isFuzzy) {
      await commit('setIsFuzzy', isFuzzy)
    },
    async resetSearchConditions({ commit }) {
      await commit('resetSearchConditions')
    },
    async getCategories({ commit, getters, state }) {
      const searchObj = getters.categorySearchObj
      await apiKnowledge
        .listCategories(searchObj)
        .then(response => {
          const { data } = response
          if (data && data.list) {
            const list = data.list
            commit('setCategories', { list })
            // 現在検索設定しているIDが非表示になった場合、検索設定から削除する
            const ids = getValuesfromNest(list, 'id', 'children')
            const searchIds = state.search.category
            const deleteIds = _.without(searchIds, ...ids)
            commit('deleteSearchCategory', deleteIds)
          }
        })
    },
    getKnowledgeLists({ dispatch, commit, getters, state }) {
      commit('listSearchStart')
      dispatch('getUserSetting')
        .then(r => {
          const searchObj = getters.listSearchObj
          const params = _.cloneDeep(searchObj)

          // 検索時以外は関連度順で検索させない
          if (!getters.isSearch && searchObj.ascending === 'score') {
            params.search_order = 'date'
            params.ascending = 'desc'
          } else {
            switch (searchObj.ascending) {
              case 'created_asc':
                params.search_order = 'date'
                params.ascending = 'asc'
                break
              case 'created_desc':
                params.search_order = 'date'
                params.ascending = 'desc'
                break
              case 'score':
                params.search_order = 'score'
                params.ascending = 'desc'
                break
              default:
                params.search_order = 'date'
                params.ascending = 'desc'
                break
            }
          }
          
          apiKnowledge
            .list(params)
            .then(response => {
              const { data } = response
              // emタグをstrongタグに変換
              // const regEmStart = new RegExp('<em>')
              // const regEmEnd = new RegExp('</em>')
              // if (data.list) {
              //   _.map(data.list, list => {
              //     list.detail = list.detail.replace(regEmStart, '<strong class="yellow">').replace(regEmEnd, '</strong>')
              //     return list
              //   })
              // }
              const { list } = data
              commit('setLists', { list })
              if (state.search.is_paginate === 0) {
                dispatch('getKnowledgeCount')
              }
            })
            .finally(() => {
              commit('listSearchEnd')
            })
        })
    },
    getKnowledgeCount({ commit, getters }) {
      const params = getters.countSearchObj
      apiKnowledge
        .searchCount(params)
        .then(r => {
          const data = r.data
          if (data.status === 0) {
            commit('setCount', data.count)
          }
        })
    },
    async getUserSetting({ rootState, commit }) {
      const { common: { device } } = rootState
      await apiCommon
        .fetchUserSetting({ setting_key: `${device}_knowledge_order_disp_settings` })
        .then(response => {
          const { data } = response
          if (data && data.status === 0) {
            if (data.setting_value) {
              const settingValue = JSON.parse(data.setting_value)
              settingValue.ascending && commit('setAscending', settingValue.ascending)
              settingValue.per_page && commit('setPerpage', settingValue.per_page)
              settingValue.hidden_keys && commit('setHiddenKeys', settingValue.hidden_keys)
            }
          }
        })
    },
    async getKnowledgeDetail({ commit, state }, id) {
      await apiKnowledge
        .detail({ id: id })
        .then(response => {
          const { data } = response
          commit('setDetail', { data })
        })
    },
    async getKnowledgeGA({ commit, state }, id) {
      const params = {
        knowledge_id: id
        // key: 'knowledge'
      }
      await apiGA
        .productCodes(params)
        .then(response => {
          const { data } = response
          commit('setProductCodes', data.product_codes)
        })
    },
    async setBookmark({ commit }, id) {
      const params = {
        type: 1, // bookmark 
        id: id,
        key: 'knowledge'
      }
      await apiBookmark
        .add(params)
        .then(response => {
          const data = response.data
          if (data.status === 0) {
            commit('setBookmark', data.after_id)
          }
        })
    },
    async removeBookmark({ commit }, id) {
      const params = {
        // type: 1, // bookmark 
        id: id
        // key: 'knowledge'
      }
      await apiBookmark
        .remove(params)
        .then(response => {
          const data = response.data
          if (data.status === 0) {
            commit('setBookmark', 0)
          }
        })
    },
    setViewLater({ commit, state }, obj) {
      const { id, afterId } = obj
      const qaId = id
      const index = _.findIndex(state.lists, list => list.id === qaId)
      commit('setViewLater', { index, afterId })
    },

    async setKnowledgeId({ commit }, value) {
      await commit('setSeachKnowledge', value)
    },
    setNoteLists({ commit }, value) {
      commit('setNoteLists', value)
    },
    getKnowledgeNote({ state, commit, dispatch }, knowledgeId) {
      // 表示前に一度リセット
      commit('resetNoteLists')
      apiNote
        .list({
          per_page: 0,
          knowledge_id: knowledgeId
        })
        .then(response => {
          const { data: { lists } } = response
          commit('setNoteLists', lists)


          // 画像設定しているユーザーのアイコンを設定する 
          _.forEach(_.filter(lists, list => list.user_file_id && list.user_file_id > 0), (list) => {
            dispatch('getFile', list.user_file_id, { root: true }).then(res => {
              commit('setUserImage', { ...list, image: res.dataUrl })
            })
          })
          // lists.forEach((tmpList) => {
          //   if (tmpList.user_file_id === 0) return
          //   apiCommon
          //     .fetchFile({ file_id: tmpList.user_file_id })
          //     .then((res) => {
          //       getDataURL(res).then((dataUrl) => {
          //         const list = { ...tmpList, image: dataUrl }
          //         commit('setUserImage', list)
          //       })
          //     })
          // })
        })
    },
    resetAllState({ commit }) {
      commit('resetAll')
    },
    resetSearchCategory({ commit }) {
      commit('resetSearchCategory')
    },
    setReferrerObject({ commit }, obj) {
      commit('setReferrer', obj)
    },
    setPrevUrlStr({ commit }, url) {
      commit('setPrevUrl', url)
    },
    setSelectedListItemId({ commit }, selectedListItemId) {
      commit('setSelectedListItemId', selectedListItemId)
    }
  }
}

export default knowledge
